import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-affaire-body" }
const _hoisted_2 = { class: "tw-affaire-title" }
const _hoisted_3 = { class: "tw-affaire-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.userNetworksList.length)
    ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
        key: 0,
        class: _normalizeClass(["tw-affaire-selector", { 'is-mini': _ctx.mini }]),
        flat: "",
        "no-caps": "",
        "dropdown-icon": "expand_more",
        "content-class": "tw-affaire-menu"
      }, {
        label: _withCtx(() => [
          _createVNode(_component_q_icon, {
            class: "tw-affaire-icon",
            name: "bookmark",
            size: "18px"
          }),
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("main.menu.activeBusiness")), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userNetworksLabel), 1)
          ]),
          (_ctx.mini)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                anchor: "center right",
                self: "center left",
                offset: [8, 0],
                class: "tw-side-nav-tooltip"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("main.menu.activeBusiness")) + " : " + _toDisplayString(_ctx.userNetworksLabel), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNetworksList, (item) => {
                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  key: item.value,
                  clickable: "",
                  onClick: ($event: any) => (_ctx.onSelectUserNetwork(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`main.networkNode.${item.label}`)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_close_popup]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}